import {
  OPEN_JOBS,
  CLOSE_JOBS,
  UPDATE_JOBS,
  START_CHECKING_JOBS,
  STOP_CHECKING_JOBS,
  ADD_GLOBAL_HANDLER,
  REMOVE_GLOBAL_HANDLER,
  GLOBAL_JOB_COMPLETED,
} from '../action-types/asyncJobTypes';

const initialState = {
  open: false,
  intervals: [],
  jobs: [],
  globalHandlers: {},
};

function asyncJobReducer(state = initialState, action) {
  switch (action.type) {
    case ADD_GLOBAL_HANDLER:
      const { id, handler, meta } = action.payload;
      return {
        ...state,
        globalHandlers: { ...state.globalHandler, [id]: { handler, meta } },
      };
    case REMOVE_GLOBAL_HANDLER:
      return {
        ...state,
        globalHandlers: { ...state.globalHandlers, [action.payload]: undefined },
      };
    case GLOBAL_JOB_COMPLETED:
      // Call each handler with the changed
      console.info(`Detected completed jobs`, action.payload);
      console.log(state.globalHandlers);
      Object.values(state.globalHandlers)
        .filter((h) => h.meta.handlerType === 'onJobComplete')
        .forEach(({ handler, meta }) => {
          if (typeof handler === 'function') {
            handler(action.payload, meta); // Call the handler with the changed jobs
          }
        });
      return state;
    case OPEN_JOBS:
      return {
        ...state,
        open: true,
      };
    case CLOSE_JOBS:
      return {
        ...state,
        open: false,
      };
    case UPDATE_JOBS:
      return { ...state, jobs: action.payload };
    case START_CHECKING_JOBS:
      return {
        ...state,
        intervals: action.payload
          ? [...state.intervals, action.payload]
          : state.intervals,
      };
    case STOP_CHECKING_JOBS:
      for (const itv of state.intervals) {
        clearInterval(itv);
      }
      return {
        ...state,
        intervals: [],
      };
    default:
      return state;
  }
}

export default asyncJobReducer;
